import React, { useState } from 'react';
import { MdClose, MdMoreVert, MdOutlineClose } from 'react-icons/md';
import Drawer from 'react-modern-drawer'
import { FiEdit } from 'react-icons/fi';


// Sample tag data
const tags = [
    { id: 4, title: 'Policy Document' },
    { id: 5, title: 'Agreement' },
    { id: 6, title: 'Contract' },
    { id: 7, title: 'Invoice' },
    { id: 8, title: 'Marketing Document' },
    { id: 9, title: 'HR Document' },
];

const PersonalTags = ({ sharedTeamTagsPopup, setSharedTeamTagsPopup }) => {
    const [activeTab] = useState('public_tag');
    const [inputVal, setInputVal] = useState('');
    const [selectedTags, setSelectedTags] = useState([]);
    const [createTagsPopup, setCreateTagsPopup] = useState(false);
    const [editTags, setEditTags] = useState(false);

    const [tagValue, setTagValue] = useState('PERSONAL FILES');

    const handleChange = (event) => {
        setTagValue(event.target.value);
    };

    // Handle search input change
    const handleSearch = (e) => {
        setInputVal(e.target.value);
    };

    // Handle tag selection
    const handleTagClick = (tag) => {
        setSelectedTags((prevSelectedTags) =>
            prevSelectedTags.includes(tag.id)
                ? prevSelectedTags.filter((id) => id !== tag.id)
                : [...prevSelectedTags, tag.id]
        );
    };

    // Filter tags based on the search input and exclude selected tags
    const filteredTags = tags
        .filter((tag) =>
            tag.title.toLowerCase().includes(inputVal.toLowerCase())
        )
        .filter((tag) => !selectedTags.includes(tag.id));

    const noResultsFound = inputVal.length > 0 && filteredTags.length === 0;

    return (
        <>
            <div className={`tagAddSearch ${activeTab}`}>
                <input
                    type="text"
                    maxLength="25"
                    onChange={handleSearch}
                    value={inputVal}
                    placeholder='Search tag or create a new one'
                />
                {inputVal.length > 0 && (
                    <span className="tagSearchCloseIcon" onClick={() => setInputVal('')}>
                        <MdClose className='text-red-600 text-2xl' />
                    </span>
                )}
            </div>
            <div className="selectedParticipants tag_container_mini">
                {selectedTags.length > 0 && selectedTags.map(tagId => {
                    const tag = tags.find(t => t.id === tagId);
                    return tag ? (
                        <div key={tagId} className="flex mr-1 mb-1 gap-2 items-center rounded-full px-3 py-0.5 text-sm" style={{ backgroundColor: tag.tag_color }}>
                            <div className="text-white"><p>{tag.title}</p></div>
                            <div className="text-white" onClick={() => handleTagClick(tag)}>
                                <MdOutlineClose />
                            </div>
                        </div>
                    ) : null;
                })}
            </div>
            <div className="tagContainer">
                {filteredTags.map((tag) => (
                    <div
                        key={tag.id}
                        className={`tagItem ${selectedTags.includes(tag.id) ? 'selected' : ''}`}
                        style={{ borderLeft: `6px solid rgb(232, 42, 135)` }}>
                        <p onClick={() => handleTagClick(tag)} className="tagTitle">{tag.title}</p>
                        <div className='tagHoverOptions' onClick={() => setCreateTagsPopup(true)}>
                            <MdMoreVert className='text-2xl -mt-2' />
                        </div>
                    </div>
                ))}
            </div>
            <div className="tagModalFoot">
                <button className="btnAction">Cancel</button>
                {noResultsFound && (
                    <button className="btnAction 77" onClick={() => setCreateTagsPopup(true)}>Create tag</button>
                )}
            </div>
            <Drawer
                open={createTagsPopup}
                onClose={() => setCreateTagsPopup(false)}
                direction='bottom'
                enableOverlay={true}
                className='rounded-lg !-bottom-3 !h-52'
                overlayClassName='customOverlay'
            >
                <div className='p-6'>
                    <div className="appBar " style={{ marginTop: '-10px', marginBottom: '20px' }}></div>
                    {
                        editTags ?
                            <>
                                <div className="tagItem" style={{ borderLeft: '6px solid rgb(232, 42, 135)', marginBottom: '15px' }}>
                                    <input
                                        type="text"
                                        className="tagsTitleEdit"
                                        id="tagValue"
                                        value={tagValue}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="deleteTagBtnCon">
                                    <button onClick={() => setEditTags(false)} className="deleteTagCancel">Cancel</button>
                                    <button class="deleteTagConfirm">Update</button>
                                </div>
                            </> :
                            <>
                                <div className="tagItem" style={{ borderLeft: '6px solid #e82a87' }}>
                                    <p className='tagTitle' >Test Tags</p>
                                </div>
                                <div className='tagPopUuOptions'>
                                    <div className='tagOptionCon'>
                                        <div className="conv_pint_home">
                                            <FiEdit className="_floatCopy"></FiEdit>
                                        </div>
                                        <div onClick={() => setEditTags(true)}>
                                            <span>Edit tag</span>
                                        </div>
                                    </div>

                                    <div className='tagOptionCon' style={{ marginTop: '6px' }}>
                                        <div className='' style={{ fontSize: '22px' }} >
                                            <span className="fileOptDetIcon delete"></span>
                                        </div>
                                        <div className='tagDeleteText'>
                                            <span>Delete tag</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                </div>
            </Drawer>
        </>
    );
};

export default PersonalTags;